import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { IndentPODetails } from './IndentPODetails';

export interface IndentPOHeaderParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface IndentPOHeader { 

    poid?:number;
    podate:any;
    suplid:string;
    grandtot:number;
    usrname:string;
    postatus:string;
    closeporeason:string;
    cancelporeason:string;
    approvalFlag:string;
    sendtoapprovalFlag:string;
    createdBy:string;
    createdDate:any;
    updatedBy:string;
    updatedDate:any;
    branchId: string;
    tenantId: string;  

    grnDiscType:string;
    grnDiscPer:number;
    grnDiscAmt:number;
    grnTaxTotal:number;
    iGst:number;
    cGst:number;
    sgstOrUtgst:number;
    creditNoteValue:number;
    returnValue:number;
    roundOffMode:string;
    roundOffAmt:number;
    grnNetTotal:number;
    comments:string;
    grnDiscValue:number;
    grnDiscTotal:number;    
    gridDiscountAfterTax: string;
    totalDiscountAfterTax: string;
    pharmacyId:any;
    poStatusJson:any;
    plannedDeliveryDate:Date;
    phPurOrderDetDto: IndentPODetails[];
    poCancelReasonType?:string | null;
    notes?:string | null;
    approvedBy?:number|null,
    approvedDate?:Date|null,
    finalVerificationByType?:string|null,
    finalVerificationByEmpId?:string|null,
    finalVerificationByPhyId?:string|null,
    finalVerificationDate?:Date|null;
    
    parameters?: IndentPOHeaderParameter[];
    links?: any;
}


export abstract class IndentPOHeaderData {
    abstract list(url: string): Observable<any>; 
    abstract getById(url: string): Observable<any>;
    abstract searchList(url: string,data:any): Observable<any>;
    abstract getall(url: string): Observable<IndentPOHeader[]>;
    abstract create(url: string, data: IndentPOHeader): Observable<IndentPOHeader[]>;
    abstract update(url: string, data: IndentPOHeader): Observable<IndentPOHeader>;
    abstract updates(url: string, data: any): Observable<any>;
}
